import {Component} from "preact";
import styles from "./style.module.scss";
import {icons} from "../icons";
import {i18nService} from "../../services/i18n-service";
import {Variant} from "../../models/product";
import {TrackingEvent} from "../../services/tracking-service";

interface Props {
  show: boolean
  onClose: () => void
  variant: Variant
}

export const EprOpenedTrackingEvent = {
  label: "EPR",
  action: "open epr overlay",
  category: "Products"
} as TrackingEvent

export class Epr extends Component<Props, any> {

  constructor() {
    super();
    this.handleKey = this.handleKey.bind(this);
  }

  private getRecycledComponents() {
    const recycledComponents = this.props.variant.components.filter(component => {
      return component.materials.some(mat => mat.recycled)
    })

    return recycledComponents.map(comp => {
      const component = comp.clone();

      component.materials = component.materials.filter(mat => mat.recycled);

      return component;
    })
  }

  private handleKey(e: KeyboardEvent) {
    if(e.key == "Enter") {
      this.props.onClose();
    }
  }

  render() {
    return (
      <div className={styles["epr-container"]}>
        {this.props.show && <div className={styles["background"]} onClick={this.props.onClose}/>}

        <div className={`${styles["panel"]} ${this.props.show ? styles["active"] : ""}`}>
          <div className={styles["wrapper"]}>
            <div className={styles["header"]}>
              <span className={styles["title"]}>{i18nService.translate("detail_view_epr_label")}</span>

              <span className={styles["close"]} onClick={this.props.onClose} tabindex={0} onKeyPress={this.handleKey}>
                {icons.renderCloseIcon()}
              </span>
            </div>

            <div className={styles["separator"]}/>

            <div className={styles["details"]}>
              <span className={styles["label"]}>{i18nService.translate("epr_origin_label")}:</span>
              <ul>
                {this.props.variant.fabrication_country && <li>{i18nService.translate("epr_fabrication_country", this.props.variant.fabrication_country)}</li>}
                {this.props.variant.enhancement_country && <li>{i18nService.translate("epr_enhancement_country", this.props.variant.enhancement_country)}</li>}
                {this.props.variant.assembling_country && <li>{i18nService.translate("epr_assembling_country", this.props.variant.assembling_country)}</li>}
              </ul>

              <span className={styles["label"]}>{i18nService.translate("epr_dangerous_material_label")}:</span>
              {this.props.variant.dangerous_substance ? (
                <div className={styles["dangerous-substance-container"]}>
                  <div className={styles["icon"]}>{icons.renderExclamationMarkIcon()}</div>
                  <span>{i18nService.translate("epr_dangerous_material_contains")}</span>
                </div>
              ) : (
                <div className={styles["dangerous-substance-container"]}>
                  <div className={styles["icon"]}>{icons.renderCheckmarkIcon()}</div>
                  <span>{i18nService.translate("epr_dangerous_material_contains_not")}</span>
                </div>
              )}

              {this.props.variant.contains_recycled_material && <div className={styles["recycled-container"]}>
                <span className={styles["label"]}>{i18nService.translate("epr_recycled_label")}:</span>

                <ul>
                  {this.getRecycledComponents().map(component => {
                    return <li>{i18nService.translate(component.translationKey())}: {component.materials.map(mat => `${mat.value}% ${i18nService.translate(mat.translationKey())}`).join(", ")}</li>
                  })}
                </ul>
              </div>}

              {this.props.variant.contains_high_microplastic && (
                <span className={styles["microplastic"]}>{i18nService.translate("epr_reject_microplastic")}</span>
              )}
            </div>
          </div>

          <div className={styles["footer"]}>
            <div className={styles["separator"]}/>

            <div className={styles["wrapper"]}>
              <button className={styles["button"]} onClick={this.props.onClose}>{i18nService.translate("epr_back_to_product")}</button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}